import { useEffect } from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import actions, { TYPES } from '../actions'
import { selectStores } from '../selectors'

function selectState(state) {
  return { currentProduct: state.app.currentProduct, stores: state.app.stores, selected: state.app.selected }
}

function StorePage({ location, match }) {
  const dispatch = useDispatch()
  const { stores } = useSelector(selectStores, shallowEqual)
  const { currentProduct, selected } = useSelector(selectState, shallowEqual)

  const showStore = async (store) => {
    dispatch(
      actions.updateApp({
        view: TYPES.VIEW_STORE_DETAILS,
        currentStore: store,
      }),
    )
  }

  const showStoreAlone = async (cnpj) => {
    dispatch(
      actions.updateApp({
        view: TYPES.VIEW_STORE_DETAILS_ALONE,
        storeAlone: cnpj,
      }),
    )
  }

  useEffect(() => {
    const cnpj = atob(match.params.cnpj)

    const haveProduct = selected.length > 0 || currentProduct

    if (match.path === '/loja/:cnpj/produtos' || !haveProduct) {
      showStoreAlone(cnpj)
      return
    }

    if (stores) {
      const store = stores.find((s) => s.cnpj === cnpj)

      showStore(store)
    }
  }, [location.key, stores, currentProduct])

  return null
}

export default StorePage
